module.exports = __webpack_public_path__ + "2171ecfae5f11dffc26a7b4d629a2492.jpg";